/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Typography,
  Button,
  Collapse,
  Modal,
  Spin,
  Input,
  Checkbox,
  Select,
} from "antd";
import "../components/projectgallery.css";
import { useBreakpoints } from "./ResponsiveBreakPoints";
import arrowIcon from "../assets/images/arrowIcon.svg";
import FlippableProjectCard from "./FlippableProjectCard";

const Projects = ({ title, categories, openEnquiryModal }) => {
  const { isSuperLarge, isMobile } = useBreakpoints();
  const { Panel } = Collapse;
  const [activeKeys, setActiveKeys] = useState(["1"]);
  const [activeTab, setActiveTab] = useState("0");
  const [selectedArea, setSelectedArea] = useState("All");
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    setSelectedArea("All");
    setSearchText("");
  }, [activeTab]);

  const activeProjects = categories[activeTab]?.projects || [];

  const uniqueAreas = [
    "All",
    ...new Set(activeProjects.map((p) => p.area_name).filter(Boolean)),
  ];

  return (
    <div id="test">
      <Row justify="center" style={{ paddingTop: 40 }}>
        <Col
          xs={22}
          sm={22}
          md={22}
          lg={18}
          xl={20}
          xxl={16}
          style={{ maxWidth: isSuperLarge ? "50%" : "" }}
        >
          <Row justify="center" gutter={[0, 10]}>
            <Col span={24}>
              <Collapse
                ghost
                activeKey={activeKeys}
                onChange={(keys) => setActiveKeys(keys)}
                expandIcon={({ isActive }) => (
                  <img
                    src={arrowIcon}
                    style={{
                      transform: `rotate(${isActive ? 180 : 0}deg)`,
                      transition: "transform 0.3s ease",
                    }}
                  />
                )}
                expandIconPosition="end"
                className="collapseClass"
              >
                <Panel
                  header={
                    <span className="propertySearch" style={{ padding: "2px" }}>
                      {title}
                    </span>
                  }
                  key="1"
                >
                  {/* Tabs */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      marginBottom: "20px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      padding: "8px",
                      width: "fit-content",
                      maxWidth: "100%",
                    }}
                  >
                    {categories.map((c, i) => (
                      <Button
                        key={i}
                        type="default"
                        style={{
                          backgroundColor:
                            activeTab === String(i) ? "#1c3988" : "transparent",
                          color: activeTab === String(i) ? "#fff" : "#1c3988",
                          fontFamily: "Roboto-500",
                          fontSize: "16px",
                          padding: "16px 12px",
                          border: "none",
                        }}
                        onClick={() => setActiveTab(String(i))}
                      >
                        {c.label}
                      </Button>
                    ))}
                  </div>

                  {/* Area Filter */}
                  {uniqueAreas.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "15px",
                        marginBottom: "20px",
                        width: "100%",
                      }}
                    >
                      <Input
                        placeholder="Search By Area, Project or Builder"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        allowClear
                        style={{
                          flex: 1,
                          minWidth: isMobile ? "100%" : "280px",
                          height: "40px",
                          borderRadius: "8px",
                          fontFamily: "Roboto-400",
                        }}
                      />

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: "Roboto-500",
                            fontSize: "16px",
                            color: "#1c3988",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Selected Area:
                        </Typography>

                        <Select
                          className="areaSelect"
                          value={selectedArea}
                          onChange={(value) => setSelectedArea(value)}
                          style={{ minWidth: "150px" }}
                          options={uniqueAreas.map((area) => ({
                            label: area,
                            value: area,
                          }))}
                        />
                      </div>
                    </div>
                  )}

                  {/* Project Cards */}
                  <Row gutter={[16, 16]}>
                    {activeProjects
                      .filter((p) =>
                        !selectedArea || selectedArea === "All"
                          ? true
                          : p.area_name === selectedArea,
                      )
                      .filter((p) => {
                        if (!searchText) return true;
                        const t = searchText.toLowerCase();
                        return (
                          p.property_name?.toLowerCase().includes(t) ||
                          p.area_name?.toLowerCase().includes(t) ||
                          p.builder?.toLowerCase().includes(t)
                        );
                      })
                      .map((p, idx) => (
                        <Col
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={12}
                          xxl={12}
                          key={idx}
                        >
                          <FlippableProjectCard
                            key={`${activeTab}-${idx}`}
                            project={p}
                            openEnquiryModal={openEnquiryModal}
                          />
                        </Col>
                      ))}
                  </Row>
                </Panel>
              </Collapse>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Projects;
